import React from 'react';
import './Features.css';
import BeforeAfterSlider from './BeforeAfterSlider';

const Features: React.FC = () => {
  const features = [
    {
      icon: '📸',
      title: 'Upload Your Selfies',
      description: 'Select 5-10 of your best photos for optimal AI training and stunning results.',
      highlight: 'Smart face detection'
    },
    {
      icon: '🎨',
      title: 'Choose Your Style',
      description: 'Browse 56+ professional and artistic styles, from business headshots to fantasy art.',
      highlight: '56+ unique styles'
    },
    {
      icon: '✨',
      title: 'Get AI Magic',
      description: 'Our advanced AI transforms your photos into stunning portraits in minutes.',
      highlight: 'High-resolution export'
    }
  ];

  return (
    <section id="features" className="features-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">How It Works</h2>
          <p className="section-subtitle">
            Three simple steps to transform your selfies into professional AI portraits
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
              <span className="feature-highlight">{feature.highlight}</span>
            </div>
          ))}
        </div>
        
        <div className="features-showcase">
          <div className="showcase-item" style={{ animationDelay: '0s' }}>
            <BeforeAfterSlider
              beforeImage="/assets/original-selfie.png"
              afterImage="/assets/styles/style_business_professional_thumb.jpg"
              styleName="Business Professional"
            />
          </div>
          <div className="showcase-item" style={{ animationDelay: '1s' }}>
            <BeforeAfterSlider
              beforeImage="/assets/original-selfie.png"
              afterImage="/assets/styles/style_cyberpunk_samurai_thumb.jpg"
              styleName="Cyberpunk Samurai"
            />
          </div>
          <div className="showcase-item" style={{ animationDelay: '2s' }}>
            <BeforeAfterSlider
              beforeImage="/assets/original-selfie.png"
              afterImage="/assets/styles/style_luxury_professional_thumb.jpg"
              styleName="Luxury Professional"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;